import {h, Component} from 'preact';
import {connect} from 'react-redux';

import reduce from '../reducers';
import * as actions from '../actions';

import store from "../store";
import constants from "../constants";
import {hasLayoutGuidesSupport, setLayoutGuides} from "../canvas/layout-guides";
import {toggleRuler, rulerIsToggled} from "../canvas/page-ruler";
import Renderer from '../canvas/renderer';
import aiService from "../service/aiService";
import MenuCopilot from "./MenuCopilot.tsx";
import util from "../util";
import Interactable from "../canvas/interactable";

export default @connect(reduce, actions)
class PageTools extends Component {

  constructor() {
    super();

    this.state = {
      showAiHelper: false,
      aiDataLoading: false,
      aiData: {}
    };

    this.showLayoutGuideBar = this.showLayoutGuideBar.bind(this);
    this.clickToggleAiHelper = this.clickToggleAiHelper.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  showLayoutGuideBar(ev) {
    const showLayoutGuides = this.props.layoutGuide === 0 ? 1 : 0;
    ev.stopPropagation();
    store.dispatch(actions.showLayoutGuideBar(true));
    store.dispatch(actions.setLayoutGuide(showLayoutGuides));
    setLayoutGuides(showLayoutGuides, this.props.layoutGuidePageMargin, this.props.layoutGuideColumnMargin);
  }

  clickToggleRuler() {
    toggleRuler();
    if (rulerIsToggled()) {
      $('#rulerToggle').addClass('act');
    } else {
      $('#rulerToggle').removeClass('act');
    }
  }

  clickToggleAiHelper(ev) {
    ev.stopPropagation();
    this.setState(prev => ({
      showAiHelper: !prev.showAiHelper
    }));

    if (!this.state.showAiHelper) {
      store.dispatch(actions.setIsLeftMenuVisible(false));
      store.dispatch(actions.setIsMOEditModal(false));
      util.nextTick(() => {
        Interactable.adjustSelectionBoxes();
      });
      $("#context-bar").hide()
    }
  }

  showSafetyZone() {
    const isSafeZoneToggled = store.getState().isSafetyZoneToggled;
    Renderer.setSafeZone(!isSafeZoneToggled);
  }

  componentDidUpdate(prevProps, prevState) {
    document.addEventListener("click", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick(event) {
    this.setState({showAiHelper: false});
  }

  render(props, state) {
    const sizeKey = $('#pages').children(':first').attr('data-size');

    return (<div className={'page-tools-group'}>
        {!window.data.member.hasViewOnlyPermission &&
          <div id="aiHelperToggle" className="page-tools">
            <div className={`btn ly-gd-bt hint--left`} onClick={this.clickToggleAiHelper}
                 data-hint="Menu Copilot">
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#magic-stars"}/>
              </svg>
            </div>
          </div>}

        <MenuCopilot active={state.showAiHelper}
                     designId={this.props.designId}
                     isPaidMember={!this.props.isFreemium}
                     setActiveMember={this.props.setActiveMember}
                     toggled={this.state.showAiHelper}
                     onClose={this.clickToggleAiHelper}
                     isPrintable={!this.props.isSocialDesign && !this.props.isLogo && !this.props.isDigitalMenuBoard && !this.props.isCustomSize}
        />

        {(sizeKey === 'custom' && store.getState().designUnit === 'in') &&
          <div className="page-tools">
            <div id="safetyZoneToggle"
                 className={`btn ly-gd-bt ${this.props.isSafetyZoneToggled ? 'act' : ''} hint--left`}
                 onClick={this.showSafetyZone} data-hint="Print Safe Zone">
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-safety-guides"}/>
              </svg>
            </div>
          </div>}
        {!store.getState().isMobileVersion && sizeKey !== 'fb-post' && sizeKey !== 'fb-story' && sizeKey !== 'insta-story' && sizeKey !== 'insta-post' &&
          sizeKey !== 'logo' && sizeKey !== 'digital-menu-board' && sizeKey !== 'digital-menu-board-portrait' && sizeKey !== 'custom' &&
          <div className="page-tools">
            <div id="safetyZoneToggle"
                 className={`btn ly-gd-bt ${this.props.isSafetyZoneToggled ? 'act' : ''} hint--left`}
                 onClick={this.showSafetyZone} data-hint="Print Safe Zone">
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-safety-guides"}/>
              </svg>
            </div>
          </div>}
        <div className="page-tools">
          <div id="rulerToggle" className={`btn ly-gd-bt hint--left`} onClick={this.clickToggleRuler}
               data-hint="Ruler">
            <svg>
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-ruler-icon"}/>
            </svg>
          </div>
        </div>
        {hasLayoutGuidesSupport(props.designSize) ? (
          <div className="page-tools">
            <div className={`btn ly-gd-bt ${this.props.layoutGuide > 0 ? 'act' : ''} hint--left`}
                 onClick={ev => this.showLayoutGuideBar(ev)} data-hint="Layout Guides">
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-layout-guide-1"}/>
              </svg>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}
